import MoveCategoryModal from './MoveCategoryModal'

export default MoveCategoryModal
